import { addToast } from '../actions/actions.export.js';

var Cookies = require('js-cookie');

const revokeTokenHandler = (e) => {
  
  if(e.message === 'Invalid signature.'){
    // Log you out and remove the auth cookie
    Cookies.remove(process.env.REACT_APP_COOKIE_AUTH);
    window.location.href = '/';
  }

  if(e.message === 'Suspended.'){
    // Log you out and remove the auth cookie
    Cookies.remove(process.env.REACT_APP_COOKIE_AUTH);
    window.location.href = '/';
  }

  if(e.message === 'Log Out.'){
    // Log you out and remove the auth cookie
    Cookies.remove(process.env.REACT_APP_COOKIE_AUTH);
    window.location.href = '/';
  }
}

export default revokeTokenHandler;


// WEBPACK FOOTER //
// ./src/pattern_utilities/revokeTokenHandler.js